import { motion, AnimatePresence } from "framer-motion";

import { useAppSelector } from "../../../store/index";
import {
  Notification,
  NotificationTypes,
} from "../../../store/notifications/slice";

import checkIcon from "../../../assets/icons/check-circle-fill.svg";
import dashIcon from "../../../assets/icons/dash-circle-fill.svg";
import WarnIcon from "../../../assets/icons/dash-circle-warn-fill.svg";
import infoIcon from "../../../assets/icons/info-circle.svg";
import infoWarnIcon from "../../../assets/icons/info-circle-warn.svg";
import infoErrorIcon from "../../../assets/icons/info-circle-error.svg";

import './Notifications.scss'

const Notifications: React.FC = () => {
  const notifications = useAppSelector(
    (store) => store.notifications.notifications
  );

  const getLeftIcon = (nType: NotificationTypes) => {
    switch (nType) {
      case NotificationTypes.error:
        return <img className="left-icon" src={dashIcon} alt="" />;
      case NotificationTypes.warning:
        return <img className="left-icon" src={WarnIcon} alt="" />;
      default:
        return <img className="left-icon" src={checkIcon} alt="" />;
    }
  };
  const getRightIcon = (nType: NotificationTypes) => {
    switch (nType) {
      case NotificationTypes.error:
        return <img className="right-icon" src={infoErrorIcon} alt="" />;
      case NotificationTypes.warning:
        return <img className="right-icon" src={infoWarnIcon} alt="" />;
      default:
        return <img className="right-icon" src={infoIcon} alt="" />;
    }
  };

  return (
    <div className="notification-wrapper">
      <AnimatePresence>
        {notifications.map(({ id, message, type, title }: Notification) => (
          <motion.div
            key={id}
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -50 }}
            transition={{ duration: 0.3 }}
            className={`notification-item ${type ?? ""}`}
          >
            {getLeftIcon(type)}
            <div className="content">
              <div className="title">{title}</div>
              {message && <div className="message">{message}</div>}
            </div>
            {getRightIcon(type)}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
};

export default Notifications;
